import { css } from 'styled-components'
import {
  notifyFadeInAnim,
  notifyFadeOutAnim,
  diceRotateAnim,
  widthChangeAnim,
  trainApearAnim,
  trainRemoveAnim,
  addRowAnim,
} from './TransitionsKeyframes'

export const notifyFadeIn = css`
  animation: ${notifyFadeInAnim};
  animation-fill-mode: forwards;
  animation-timing-function: linear;
`
export const notifyFadeOut = css`
  animation: ${notifyFadeOutAnim};
  animation-fill-mode: forwards;
  animation-timing-function: linear;
`
export const diceRotate = css`
  animation: ${diceRotateAnim} 0.3s 1 forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const clickDown = css`
  transform: scale(0.65);
  transition: all 0.167s;
  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const clickUp = css`
  transform: scale(1);
  transition: all 0.167s;
  transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const widthChange = css`
  animation: ${widthChangeAnim} 0.3s 1 forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`

export const trainRemove = css`
  animation: ${trainRemoveAnim} 0.167s 1 forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const trainAppear = css`
  animation: ${trainApearAnim} 0.167s 1 forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
export const addRow = css`
  animation: ${addRowAnim} 0.167s 1 forwards;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
`
